import { PickerValidDate } from '@mui/x-date-pickers';

export function propertyExists<X, Y extends PropertyKey>(
  obj: X,
  prop: Y
): obj is X & Record<Y, unknown> {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    Object.prototype.hasOwnProperty.call(obj, prop)
  );
}

export function getTimezone(
  adapter: any,
  value: PickerValidDate
): string | null {
  if (!adapter) return null;
  return value == null || !adapter.isValid(value)
    ? null
    : adapter.getTimezone(value);
}

export function readValueAsDate<TDate extends PickerValidDate>(
  adapter: any,
  value: string | null | TDate
): TDate | null {
  if (!adapter) return null;
  if (typeof value === 'string') {
    if (value === '') {
      return null;
    }
    return adapter.date(value) as TDate;
  }
  return value;
}
